export default {
  OPERACION_GRUPO_OPCION: (state, mutation) => {
    state.operacion = mutation.oper
    state.id = mutation.id
  },
}
